import React from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ReliabilityERPSoftware from '../molecules/ERPSoftwareComponents/ReliabilityERPSoftware'
import ERPIdeaProjects from '../molecules/ERPSoftwareComponents/ERPIdeaProjects'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import ERPKeyFeatures from '../molecules/ERPSoftwareComponents/ERPKeyFeatures'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import AppsMaintenance from '../molecules/AppsSupportComponents/AppsMaintenance/AppsMaintenance'
import { getPageData, useData } from '../../app/helper/functions'

const ERPSoftwareDevPage = () => {
    const { loading, data, error } = useData();
    const erpSoftwareData = getPageData(data, 'erpSoftwarePage');
    return (
        <div>
            <div className='bg-erpSoftware-bg bg-center bg-cover bg-no-repeat'>
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col justify-center items-center px-[10%] gap-6 pt-52 pb-8'>
                        {/* <img src={images.ENTERPRISEHOMEIMAGE} className='z-10 w-[60%]' /> */}
                        <div className='z-10 w-[60%] h-[200px]'></div>
                        <div className='text-white flex flex-col gap-2 relative text-center justify-center items-center'>
                            <div className='font-bold text-6xl mb-2'>{erpSoftwareData.title}</div>
                            <div className='font-normal text-2xl'>{erpSoftwareData.description}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-darkGreyPrimary'>
                <Heading className='bg-darkGreyPrimary py-12'
                    title='BENEFITS'
                    subTitle='Why go for custom ERP software?'
                    text='Pre-made ERP systems may not meet the unique demands of expanding businesses. Custom ERP software unifies
                    all processes into one system for efficient operation and adaptability.' />
                <ReliabilityERPSoftware erpSoftwareData={erpSoftwareData} />
                <ERPIdeaProjects erpSoftwareData={erpSoftwareData} />
                <div className='pt-10 bg-darkGreyPrimary'>
                    <AppsRunning bgImage='bg-confident-erp-bg'
                        title='Key features of our ERP solutions'
                        subtitle='Our unique ERP software is designed to optimize your business operations by giving you full visibility
                        and control over all processes. Common features we offer include:' />
                </div>
                <ERPKeyFeatures erpSoftwareData={erpSoftwareData} />
                <ProjectDisplay />
                <AppsFaq />
                <AppsMaintenance bgImage='bg-maintenance-hospital-bg'
                    title='Start your ERP software development project today'
                    subtitle='Want to enhance patient care and simplify data management with a tailored EPD/EHR system?' />
                <DefaultFooter />
            </div>
        </div>
    )
}

export default ERPSoftwareDevPage
